<script>
import { request } from "@/common/mixins/mix_helper";
import { loader } from "@/common/mixins/mix_loader";
import { clientCookies } from "@/common/mixins/mix_cookies";
import { mapGetters } from "vuex";

export default {
  name: "ModuleRating",
  mixins: [clientCookies, loader, request],
  data() {
    return {
      form: {
        ratingValue: "",
        ratingMessage: "",
        tellMeMore: [],
      },
      ratingFace: {
        tear: "1",
        sad: "2",
        meh: "3",
        smile: "4",
        laugh: "5",
      },
      tellMeMore: {
        satu: [
          "Tidak ramah",
          "Tidak memberi solusi",
          "Bahasanya belibet",
          "Tidak membantu",
        ],
        dua: [
          "Kurang ramah",
          "Kurang memberi solusi",
          "Kurang pengetahuan",
          "Kurang membantu",
        ],
        global: [
          "Tidak membantu",
          "Masalah belum selesai",
          "Tidak mudah dipahami",
          "Respon Lambat",
          "Tidak Ramah",
        ],
      },
    };
  },
  methods: {
    onCheck() {
      try {
        if (this.form.ratingValue === "") {
          throw "Pilih rating terlebih dahulu";
        }

        const text = this.getText();
        if (
          ["1", "2", "3"].includes(this.form.ratingValue) &&
          !text.trim().length
        ) {
          throw "Mohon mengisi ulasan terlebih dahulu.";
        }

        if (
          this.getConfigJs.endType !== "case-closed" &&
          parseInt(this.form.ratingValue) <= 3
        ) {
          this.$bvModal.show("end_custom");
        } else {
          this.sendRating();
        }
      } catch (e) {
        this.$swal("", e, "info");
      }
    },

    sendRating: function () {
      if (this.form.ratingValue !== "") {
        const text = this.getText();
        if (
          ["1", "2", "3"].includes(this.form.ratingValue) &&
          !text.trim().length
        ) {
          this.$swal("", "Mohon mengisi ulasan terlebih dahulu.", "info");
          return;
        }

        let roti = this.getCookies();
        if (
          roti &&
          typeof roti.customer !== "undefined" &&
          typeof roti.customer.id !== "undefined"
        ) {
          this.loading();
          this.API.post(this.URL.thread.rating, {
            star: this.form.ratingValue,
            message: text,
          })
            .then(() => {
              this.handleRatingSuccess();
            })
            .catch(() => {
              this.handleRatingSuccess();
            })
            .finally(() => {
              this.loading(false);
            });
        } else {
          this.handleLogoutFirebase();
        }
      } else {
        this.$swal("Warning", "Please choose rating first.", "warning");
      }
    },

    /**
     * --------------------------------------------------------------
     * helper for trigger if send rating
     * --------------------------------------------------------------
     */
    handleRatingSuccess() {
      let text = "Rating dan ulasan terkirim";
      if (["1", "2"].includes(this.form.ratingValue)) {
        if (
          this.form.tellMeMore.includes("Tidak membantu") ||
          this.form.tellMeMore.includes("Masalah belum selesai")
        ) {
          text = `<p class="text-left">Terima kasih atas review Anda. Sebagai informasi, beberapa request dan keluhan tidak dapat dilayani melalui chat karena:</p>
          <ol style="padding-left: 1em;">
            <li class="text-left">Membutuhkan waktu analisa yang lebih lama; atau</li>
            <li class="text-left">Membutuhkan otorisasi via email dari pemilik akun karena Rumahweb harus melakukan perubahan pada akun pelanggan; atau</li>
            <li class="text-left">Masalah harus di-eskalasikan ke technical support level 2 atau 1;</li>
          </ol>
          <p class='text-left'>Jika Anda telah mengirimkan permintaan bantuan melalui email / trouble ticket, silahkan menunggu respon dari kami. Sekali lagi mohon maaf atas ketidaknyamanannya.</p>`;
        }
      }

      this.cookiesSyncUpdate({ rating: { uuid: null, endtime: null } });
      this.form.ratingMessage = "";
      this.$swal({ title: "", html: text, icon: "success" });
    },

    getCookies: function () {
      let roti = this.cookiesGet();
      if (roti) {
        return roti;
      } else {
        this.cookies.remove();
        location.reload();
      }
      return false;
    },

    tellMeChecked(word) {
      return this.form.tellMeMore.includes(word);
    },

    getText() {
      let tellMeMore = this.form.tellMeMore;
      let text = "";
      Array.from(tellMeMore).forEach((a) => (text += `- ${a}\n`));

      if (this.form.ratingMessage.trim() !== "") {
        if (["1", "2"].includes(this.form.ratingValue) && tellMeMore.length) {
          text += "catatan: ";
        }
        text += `${this.form.ratingMessage}`;
      }
      return text;
    },

    /**
     * --------------------------------------------------
     * custom end chat ex. customer-away || pending-ticket
     * --------------------------------------------------
     */
    reopenThreadEndCustom() {
      try {
        const text = this.getText();
        if (text.trim() === "") {
          throw "Silakan masukan ulasan terlebih dahulu";
        }

        this.loading();
        this.$bvModal.hide("end_custom");
        this.API.post(this.URL.thread.reopen_custom_end, {
          message: text,
          rating: this.form.ratingValue,
        })
          .catch((err) => {
            this.$swal("", err.response.data.message, "error");
          })
          .finally(() => {
            this.cookiesSyncUpdate({ rating: { uuid: null, endtime: null } });
            this.form.ratingMessage = "";
            this.loading(false);
          });
      } catch (e) {
        this.$swal("", e, "info");
      }
    },
  },
  computed: {
    tellMeMoreShow() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.form.tellMeMore = [];
      let val = this.form.ratingValue;
      return ["1", "2"].includes(val);
    },

    tellMeMoreStar() {
      let star = this.form.ratingValue;
      switch (star) {
        case "1":
          star = "global";
          break;
        case "2":
          star = "global";
          break;
      }
      return star;
    },
    ...mapGetters(["getConfigJs"]),
  },
};
</script>

<template>
  <div>
    <p class="text-center mt-2 px-3">
      Seberapa puas Anda dengan pelayanan sesi percakapan ini ?
    </p>
    <div class="rating flex justify-center gap-2 mb-2">
      <label v-for="(value, faceName) in ratingFace" :key="faceName">
        <input type="radio" v-model="form.ratingValue" :value="value" />
        <img
          :src="`/img/svg/emot-rate/${faceName}.svg`"
          :alt="faceName"
          class="emot-fill"
        />
        <img
          :src="`/img/svg/emot-rate/${faceName}-line.svg`"
          :alt="faceName"
          class="emot-line"
        />
      </label>
    </div>

    <template v-if="tellMeMoreShow">
      <div class="small pl-1">Beri tahu kami, apa yang kurang :</div>
      <div
        class="tell-me-more btn-group-toggle btn-group-sm my-1 d-flex align-items-center flex-wrap"
      >
        <label
          class="btn"
          :class="tellMeChecked(i) ? 'btn-dark' : 'btn-outline-dark'"
          v-for="i in tellMeMore[tellMeMoreStar]"
          :key="i"
        >
          <input type="checkbox" :value="i" v-model="form.tellMeMore" />
          <div v-html="i"></div>
        </label>
      </div>
    </template>

    <textarea
      @keyup.enter="onCheck()"
      class="form-control"
      style="font-size: 0.8rem"
      v-model="form.ratingMessage"
      placeholder="Tinggalkan penilaian dan ulasan disini"
    />
    <br />
    <button class="btn btn-info rw-bg-3 border-0 btn-block" @click="onCheck">
      Kirim
    </button>

    <b-modal
      id="end_custom"
      :title="
        getConfigJs.endType === 'customer-away'
          ? 'Ingin lanjut chat?'
          : 'Case Anda diproses via tiket'
      "
      no-close-on-esc
      hide-footer
      no-close-on-backdrop
    >
      <p v-if="getConfigJs.endType === 'customer-away'">
        Mohon maaf jika chat kami tutup karena Anda tidak merespon. Klik "<b
          >Lanjutkan Chat</b
        >" untuk melanjutkan chat.
      </p>
      <template v-if="getConfigJs.endType === 'pending-ticket'">
        <p>
          Mohon maaf atas ketidaknyamanannya. Case Anda diproses melalui trouble
          ticket.
        </p>
        <p>
          Silahkan memantau ticket <b>{{ getConfigJs.ticketId }}</b> melalui
          email <b>{{ getConfigJs.ticketEmail }}</b> atau melalui Clientzone dan
          mohon merespon apabila kami membutuhkan konfirmasi atau informasi
          tambahan
        </p>
      </template>

      <div class="flex gap-3 justify-center">
        <button
          class="btn btn-primary w-full rw-bg-3 border-0"
          @click="reopenThreadEndCustom"
        >
          Lanjutkan Chat
        </button>
        <button
          class="btn btn-outline btn-outline-secondary w-full"
          @click="sendRating"
        >
          Tutup
        </button>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
.tell-me-more {
  label {
    display: flex;
    align-items: center;
    height: 1.5em;
    margin: 0.2em;

    div {
      font-size: 0.7em;
    }
  }
}
</style>
